import $ from "jquery";
import { useEffect } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { NavLink } from "react-router-dom";
import {
  MenuAutomationCenterIcon,
  MenuItemAgenciesIcon,
  MenuItemAnnouncementsIcon,
  MenuItemBalanceRequestsIcon,
  MenuItemHomeIcon,
  MenuItemInsuranceCompaniesIcon,
  MenuItemInsurancesIcon,
  MenuItemInvoicesIcon,
  MenuItemLeadsIcon,
  MenuItemMessageRequestsIcon,
  MenuItemPaperReqesutsIcon,
  MenuItemProfitsIcon,
  MenuItemReceivedInsurancesIcon,
  MenuItemReportsIcon,
  MenuItemResidenceAppointments,
  MenuItemSettingsIcon,
  MenuItemTranslationsIcon,
  MenuItemUsersIcon,
  MenuSmsMessagesIcon,
  MenuItemWhatsappDevicesIcon,
} from "../../../libs/SVGIcons";
export default function Menu({ menuItems, handler }) {
  const getIcon = (iconTitle) => {
    let iconELement = null;
    switch (iconTitle) {
      case "home":
        iconELement = <MenuItemHomeIcon />;
        break;
      case "insurances":
        iconELement = <MenuItemInsurancesIcon />;
        break;
      case "received-insurances":
        iconELement = <MenuItemReceivedInsurancesIcon />;
        break;
      case "balance-requests":
        iconELement = <MenuItemBalanceRequestsIcon />;
        break;
      case "paper-requests":
        iconELement = <MenuItemPaperReqesutsIcon />;
        break;
      case "reports":
        iconELement = <MenuItemReportsIcon />;
        break;
      case "automation-center":
        iconELement = <MenuAutomationCenterIcon />;
        break;
      case "users":
        iconELement = <MenuItemUsersIcon />;
        break;
      case "settings":
        iconELement = <MenuItemSettingsIcon />;
        break;
      case "insurance-companies":
        iconELement = <MenuItemInsuranceCompaniesIcon />;
        break;
      case "profits":
        iconELement = <MenuItemProfitsIcon />;
        break;
      case "financial-requests":
        iconELement = <MenuItemInsurancesIcon />;
        break;
      case "agencies":
        iconELement = <MenuItemAgenciesIcon />;
        break;
      case "translations":
        iconELement = <MenuItemTranslationsIcon />;
        break;
      case "expenses":
        iconELement = <MenuItemInsurancesIcon />;
        break;
      case "announcements":
        iconELement = <MenuItemAnnouncementsIcon />;
        break;
      case "leads":
        iconELement = <MenuItemLeadsIcon />;
        break;
      case "message-requests":
        iconELement = <MenuItemMessageRequestsIcon />;
        break;
      case "residence-appointments":
        iconELement = <MenuItemResidenceAppointments />;
        break;
      case "bulk-ratios-requests":
        iconELement = <MenuItemInsurancesIcon />;
        break;
      case "invoices":
        iconELement = <MenuItemInvoicesIcon />;
        break;
      case "sms-messages":
        iconELement = <MenuSmsMessagesIcon />;
        break;
      case "whatsapp-devices":
        iconELement = <MenuItemWhatsappDevicesIcon />;
        break;
    }
    return iconELement;
  };
  useEffect(() => {
    $(".nav-item a").removeClass("active");
    return () => {};
  }, []);
  return (
    <>
      <ul className="nav">
        {menuItems.map((menuItem, index) => {
          if (!menuItem) {
            return null;
          }
          if (!menuItem.subMenu) {
            return (
              <li className="nav-item" key={"MenuItem" + index}>
                <NavLink id={"MenuItemN" + index} to={"/app" + menuItem.path}>
                  {getIcon(menuItem.icon)}
                  <span className="title">{menuItem.title}</span>
                </NavLink>
              </li>
            );
          } else {
            return (
              <li
                className="nav-item menu-item-n"
                key={"MenuItem" + index}
                id={"MenuItemC" + index}
              >
                <NavLink
                  id={"MenuItemN" + index}
                  to={menuItem.path}
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.innerWidth >= 576) {
                      window.burgerButtonClicked(true);
                    }
                    $(".menu-item-n .angle")
                      .not("#MenuItemC" + index + " .angle")
                      .removeClass("active");
                    $(".menu-item-n .sub-menu")
                      .not("#MenuItemC" + index + " .sub-menu")
                      .removeClass("show");
                    //toggle submenu
                    $("#MenuItemN" + index + " .angle").toggleClass("active");
                    $(".sub-menu" + index).toggleClass("show");
                  }}
                >
                  {getIcon(menuItem.icon)}
                  <span className="title">{menuItem.title}</span>
                  <span className="angle">
                    <MdKeyboardArrowDown />
                  </span>
                </NavLink>
                {/* submenu */}
                <ul className={"sub-menu sub-menu" + index}>
                  {menuItem.subMenu.map((submenuItem, index) => {
                    if (!submenuItem) {
                      return null;
                    }
                    return (
                      <li className="nav-item" key={"SubMenuItem" + index}>
                        <NavLink
                          id={"SubMenuItemN" + index}
                          to={"/app" + submenuItem.path}
                          onClick={() => {
                            $(".sidebar-container").removeClass(
                              "sidebar-container-show"
                            );
                            $(window).unbind("click");
                          }}
                        >
                          <span className="title">{submenuItem.title}</span>
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          }
        })}
      </ul>
    </>
  );
}
